import React, { useRef} from "react";
import LifeQuoteDetail from "./LifeQuoteDetail.jsx";
import LifeQuoteEnquiry from "./LifeQuoteEnquiry.jsx";
import LifeQuotationCard from "./LifeQuotationCard.jsx";
import "./IndexLife.css";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { CalculateUserAge, TermLifeLoaderBox, countTrueValuesBenefit, countTrueValuesRiders, generateLotNo, getAge } from "./UtilityComponents/UtilityFunction.js";
import { useLocation } from "react-router-dom";
import QuoteFooter from "./QuoteFooter.jsx";
import { ApiSingleton } from "../App.js";
import * as moment from "moment";
import { BsStars } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa6";
import html2pdf from "html2pdf.js";
import UserActivityDetection from "./MouseAwayPop/UserActivityDetectionPopup.jsx";
import MouseAwayPopup from "./MouseAwayPop/MouseAwayPopup.jsx";
import QuoteWaitingModal from "./UtilityComponents/QuoteWaitingModal.jsx";

const SmcLifeQuote = ({ history }) => {
    const [PrvTwoData, setPrvTwoData] = useState([]);
    const [Response, setResponse] = useState([]);
    const [allResponse, setAllResponse] = useState([]);
    const [QuoteRequest, setQuoteRequest] = useState(null);
    const [QuoteReq, setQuoteReq] = useState(null);
    const [isQuotePresent, setIsQuotePresent] = useState(false);
    const [InsurerList, setInsurerList] = useState();
    const [showEdit, setShowEdit] = useState(false);
    const [isLoader, setLoader] = useState(false);
    const [isPageLoaded, setLoaded] = useState(false);
    const [IsFromWomenComponent, setIsFromWomenComponent] = useState(false);
    const [IsFromHouseWifeComponent, setIsFromHouseWifeComponent] = useState(false);
    const [IsAscendingOrder, setAscendingOrder] = useState(true);
    const [gstEnable, setGstEnable] = useState(false);
    const location = useLocation();
    const [progress, setProgress] = useState(0);
    const [allCompltedApi, setAllCompletedApi] = useState(0);
    const [RiderDetails, setRiderDetails] = useState(null);
    const [OccupationList, setOccupationList] = useState([]);
    const [EducationList, setEducationList] = useState([]);
    const [selectedQuoteKey, setSelectedQuoteKey] = useState('')
    const [scroll, setScroll] = useState(false);
    const [pendingRequests, setPendingRequests] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [downloadQuotePDF, setDownloadQuotePDF] = useState(false);
    const [showActivityDetectionPopup, setShowActivityDetectionPopup] = useState(false);
    const [goToContact, setGoToContact] = useState(false);
    const [isPopupClosed, setIsPopupClosed] = useState(false);
    const [hiddenQuotes, setHiddenQuotes] = useState([]);
    const [isQuoteLoading, setQuoteLoading] = useState(false);

    const timeoutRef = useRef(null);

    let inactivityTimer;

    useEffect(() => {
        const resetTimer = () => {
            clearTimeout(inactivityTimer);
            if (!isPopupClosed) {
                inactivityTimer = setTimeout(() => {
                    setShowActivityDetectionPopup(true);
                }, 30000);
            }
        };

        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("keydown", resetTimer);
        window.addEventListener("click", resetTimer);
        window.addEventListener("scroll", resetTimer);

        resetTimer();

        return () => {
            clearTimeout(inactivityTimer);
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            window.removeEventListener("click", resetTimer);
            window.removeEventListener("scroll", resetTimer);
        };
    }, [isPopupClosed]);

    const handlePopupClose = () => {
        setShowActivityDetectionPopup(false);
        setIsPopupClosed(true);
    };

    function getCallBack(MobileNo) {
        const Model = {
            URL: "MobileCallback",
            PostString: JSON.stringify({
                "MobileNo": MobileNo,
                "InterestedIn": "Term life Plan",
                "NextCallTime": "Evening(10AM-6PM)"
            })
        }
        axios.post("central/centralcall/CallReqWithHeader", Model)
            .then((response) => {
                setGoToContact(true);
            });
    }

    const incrementPendingRequests = () => setPendingRequests((prev) => prev + 1);
    const decrementPendingRequests = () => setPendingRequests((prev) => prev - 1);


    const callQuote = async (payload) => {
        const Model = {
            URL: "GetQuotes",
            PostString: JSON.stringify(payload),
        };
        return await axios.post("central/centralcall/CallReqWithHeader", Model);
    };

    const { formReq, occupationOptions, isHousewife, allTermLifePath } = location.state || {};
    //console.log(occupationOptions, "OccPn")
    const getQuotes = async (insurerId, lotNo) => {

        setShowEdit(true);
        let req = QuoteRequest;
        req.InsurerId = insurerId.Key;
        req.LotNo = lotNo;
        req.PolicyTerm = parseInt(req.CoverTillAge) - CalculateUserAge(QuoteRequest.DoB)
        if (insurerId.Key === 156) {
            req.isAutoPay = QuoteRequest?.isAutoPay;
        }
        incrementPendingRequests();
        setQuoteRequest(req);
        sessionStorage.setItem('request', JSON.stringify(req));
        try {
            let { data } = await callQuote(req);
            if (data.StatusCode === 200 && data?.Data?.length > 0) {
                let qtResponse = data.Data;
                qtResponse.forEach((res) => {
                    res.InsurerId = insurerId.Key;
                    res.Email = QuoteRequest.Email ? QuoteRequest.Email : QuoteRequest.EmailID;
                    res.MobileNo = QuoteRequest.MobileNo;
                });
                let totalQuotes = qtResponse.filter((data) => data.NetPremium > 0 && data.QuoteStatus)
                setResponse((prev) => [...prev, ...totalQuotes]);
                setAllResponse((prev) => [...prev, ...totalQuotes]);
                const ResponseStored = JSON.parse(sessionStorage.getItem("response")) ?? []
                sessionStorage.setItem('response', JSON.stringify([...ResponseStored, ...totalQuotes]));
                setLoader(false)

            }
            else {
                setShowEdit(true);
                setLoader(false);
            }
        } catch (err) {
        }
        finally {
            setAllCompletedApi(prev => prev + 1);
            decrementPendingRequests();
        }
    };

    const handleGst = (data) => {
        setGstEnable(data);

    }

    useEffect(() => {
        if (pendingRequests === 0) {
            setIsLoading(false); // Stop the loader
        }
    }, [pendingRequests]);

    const getQuotation = () => {
        sessionStorage.removeItem('response');
        setResponse([]);
        setAllResponse([]);
        setLoader(true);
        setProgress(0);
        setPendingRequests(0)
        setAllCompletedApi(0)
        setIsLoading(true);
        const lotNo = generateLotNo((QuoteRequest ?? { EnquiryNo: "SMC/ENQ/24/654321" }).EnquiryNo, 0);
        for (let i = 0; i < InsurerList.length; i++) {
            getQuotes(InsurerList[i], lotNo);
        }
        setIsQuotePresent(false);
    };
    const GetSharedDetails = async (shareid) => {
        const prm = new URLSearchParams(window.location.search);
        let req = {};
        if (prm.get('shareid')) {
            req = { shareToken: prm.get('shareid'), Stage: "QUOTATION", enquiryno:'' }
        } else {
            req = { enquiryno: prm.get('enquiryno'), shareToken:'0'}
        }
        const Model = {
            URL: "GetDetails",
            PostString: JSON.stringify(req)
        }
        const { data } = await axios.post("central/centralcall/CallReqWithHeader", Model);

        setInsurerList(data.NewEnquiryResponse.InsurerList);
        const QuotationReq = data.Quotations[0]?.QuotationRequest;
        QuotationReq.LotNo = data.LotNo;
        setQuoteReq(QuotationReq);
        setQuoteRequest(QuotationReq);
        handleRiderBenefitCount(QuotationReq);

        let quotes = data.Quotations.flatMap(({ QuotationResponse }) => QuotationResponse?.Data?.filter(r => r.QuoteStatus === true));
        quotes = quotes.map(r => ({
            ...r,
            InsurerId: r?.CompanyId,
            Email: QuotationReq?.EmailID,
            MobileNo: QuotationReq?.MobileNo
        }));
        setResponse(quotes);
        setAllResponse(quotes);
        setLoaded(true);
        setShowEdit(true);
    }

    const handleRiderBenefitCount = (QuoteRequest) => {
        const riderBenefitCount = {
            IsAccidentalDeathBenefit: QuoteRequest.IsAccidentalDeathBenefit,
            IsPremiumProtectionBenefit: QuoteRequest.IsPremiumProtectionBenefit,
            IsPremiumWaiverBenefit: QuoteRequest.IsPremiumWaiverBenefit,
            IsAccidentalDisabilityRider: QuoteRequest.IsAccidentalDisabilityRider,
            IsCriticalIllnessRider: QuoteRequest.IsCriticalIllnessRider,
            IsTerminalIllnessRider: QuoteRequest.IsTerminalIllnessRider,
            IsPersonalAccidentRider: QuoteRequest.IsPersonalAccidentRider,
            IsAccidentalDeathRider: QuoteRequest.IsAccidentalDeathRider,
            IsHospitalCareRider: QuoteRequest.IsHospitalCareRider,
        }
        sessionStorage.setItem("benefitCount", countTrueValuesBenefit(riderBenefitCount))
        sessionStorage.setItem("riderCount", countTrueValuesRiders(riderBenefitCount))
    }
    useEffect(() => {
        const prm = new URLSearchParams(window.location.search);
        if (prm.has("shareid") || prm.has("enquiryno") ) {
            GetSharedDetails(prm.get("shareid"))
        } else {
            setInsurerList(history?.location?.state?.InsurerList);
            setQuoteReq(history?.location?.state?.Req);
            let storedRequest = sessionStorage.getItem('request');
            sessionStorage.setItem('request', storedRequest);
            if (storedRequest) {
                setQuoteRequest(JSON.parse(storedRequest));
                storedRequest = JSON.parse(storedRequest);
                setQuoteReq(storedRequest);

            } else {

                setQuoteRequest(history?.location?.state?.QuoteReq);
            }
            setIsFromWomenComponent(location?.state?.IsFromWomenComponent ?? false);
            setIsFromHouseWifeComponent(location?.state?.IsFromHouseWifeComponent ?? false);

            /*if (isQuotePresent) {
                getQuotation();
            } else {*/


            const storedResponse = sessionStorage.getItem('response');
            if (storedResponse) {
                setResponse(JSON.parse(storedResponse));
                setAllResponse(JSON.parse(storedResponse));
                setShowEdit(true);
            }
            else {
                setIsQuotePresent(true);
            }
            /* }*/
            setLoaded(true);
        }
    }, []);
    useEffect(() => {
        if (QuoteReq) {

            let IsAddonRidersAndBenefits = {
                IsAccidentalDeathBenefit: QuoteReq.IsAccidentalDeathBenefit ?? false,
                IsPremiumProtectionBenefit: QuoteReq.IsPremiumProtectionBenefit ?? false,
                IsPremiumWaiverBenefit: QuoteReq.IsPremiumWaiverBenefit ?? false,
                IsAccidentalDisabilityRider: QuoteReq.IsAccidentalDisabilityRider ?? false,
                IsCriticalIllnessRider: QuoteReq.IsCriticalIllnessRider ?? false,
                IsTerminalIllnessRider: QuoteReq.IsTerminalIllnessRider ?? false,
                IsPersonalAccidentRider: QuoteReq.IsPersonalAccidentRider ?? false,
                IsAccidentalDeathRider: QuoteReq.IsAccidentalDeathRider ?? false,
                IsHospitalCareRider: QuoteReq.IsHospitalCareRider ?? false
            }

            let IsAddonRidersAndBenefitsSumInsured = {
                RiderAccidentalDisabilitySumInsured: QuoteReq.RiderAccidentalDisabilitySumInsured ?? 0,
                RiderCriticalIllnessSumInsured: QuoteReq.RiderCriticalIllnessSumInsured ?? 0,
                RiderTerminalIllnessSumInsured: QuoteReq.RiderTerminalIllnessSumInsured ?? 0,
                RiderPersonalAccidentSumInsured: QuoteReq.RiderPersonalAccidentSumInsured ?? 0,
                RiderAccidentalDeathSumInsured: QuoteReq.RiderAccidentalDeathSumInsured ?? 0,
                RiderHospitalCareSumInsured: QuoteReq.RiderHospitalCareSumInsured ?? 0

            }
            setRiderDetails(prv => ({ ...prv, ridersAndBenefit: { ...IsAddonRidersAndBenefits, ...IsAddonRidersAndBenefitsSumInsured } }));
        }
    }, [QuoteReq])


    useEffect(() => {
        if (isQuotePresent)
            getQuotation();
    }, [isQuotePresent])

    const callMasterAPI = async () => {
        const instance = ApiSingleton.getInstance();
        const result = await instance.fetchData();
        setOccupationList(result.OccupationList);
        setEducationList(result.EducationList);
    }

    const getQuoteOnchange = (name, value, QuoteCall) => {
        switch (name) {
            case "Cover":
                QuoteRequest.SumInsured = value;
                break;
            case "Coverage":
                QuoteRequest.CoverTillAge = value;
                QuoteRequest.PolicyTerm = parseInt(value) - CalculateUserAge(QuoteRequest.DoB);
                break;
            case "Payfrequency":
                if (QuoteRequest.PremiumFrequency === 'S' && value !== "S") {
                    QuoteRequest.PayTerm = QuoteRequest.PolicyTerm;
                }
                QuoteRequest.PremiumFrequency = value;


                break;
            case "PayFor":
                if ((parseInt(QuoteRequest.CoverTillAge) - CalculateUserAge(QuoteRequest.DoB)) < parseInt(value))
                    return alert("Payment Term can't be greater than policy term");
                if (value === 0)
                    QuoteRequest.PayTerm = (parseInt(QuoteRequest.CoverTillAge) - CalculateUserAge(QuoteRequest.DoB));
                else QuoteRequest.PayTerm = value;
                break;
            default:
                break;
        }
        if (!QuoteCall)
            getQuotation();
    };

    const UpdateResult = (upReq) => {
        //const age = getAge(upReq.DOB);
        QuoteRequest.Gender = upReq.Gender;
        QuoteRequest.DoB = moment(upReq.DOB).format("YYYY-MM-DD");
        QuoteRequest.MobileNo = upReq.MobileNo;
        QuoteRequest.IsSmoker = upReq.Detail === "N" ? false : true;
        QuoteRequest.EmailID = upReq.Email;
        QuoteRequest.Occupation = upReq.Occupation;
        QuoteRequest.Education = upReq.Education;

        getQuotation();
    };


    useEffect(() => {
        if (Response.length > 0) {
            Response.map((i) => setPrvTwoData((prev) => [...prev, i]));
        }
    }, [Response]);
    useEffect(() => {
        if (allCompltedApi > 0 || Response.length > 0) {
            updateProgress();
        }
    }, [allCompltedApi]);

    const updateProgress = () => {
        const totalQuotes = InsurerList.length;
        const fetchedQuotes = allCompltedApi;
        const percentage = totalQuotes > 0 ? (fetchedQuotes / totalQuotes) * 100 : 0;
        setProgress(percentage);
    };


    const CallQuoteWithRiderAddons = (dataObj) => {
        const { ridersAndBenefit, riderSumInsured } = dataObj;
        QuoteRequest.IsAccidentalDeathBenefit = ridersAndBenefit.IsAccidentalDeathBenefit ?? false;
        QuoteRequest.IsPremiumProtectionBenefit = ridersAndBenefit.IsPremiumProtectionBenefit ?? false;
        QuoteRequest.IsPremiumWaiverBenefit = ridersAndBenefit.IsPremiumWaiverBenefit ?? false;
        QuoteRequest.IsAccidentalDisabilityRider = ridersAndBenefit.IsAccidentalDisabilityRider ?? false;
        QuoteRequest.IsCriticalIllnessRider = ridersAndBenefit.IsCriticalIllnessRider ?? false;
        QuoteRequest.IsTerminalIllnessRider = ridersAndBenefit.IsTerminalIllnessRider ?? false;
        QuoteRequest.IsPersonalAccidentRider = ridersAndBenefit.IsPersonalAccidentRider ?? false;
        QuoteRequest.IsAccidentalDeathRider = ridersAndBenefit.IsAccidentalDeathRider ?? false;
        QuoteRequest.IsHospitalCareRider = ridersAndBenefit.IsHospitalCareRider ?? false;

        QuoteRequest.RiderAccidentalDisabilitySumInsured = riderSumInsured.RiderAccidentalDisabilitySumInsured;
        QuoteRequest.RiderCriticalIllnessSumInsured = riderSumInsured.RiderCriticalIllnessSumInsured;
        QuoteRequest.RiderTerminalIllnessSumInsured = riderSumInsured.RiderTerminalIllnessSumInsured;
        QuoteRequest.RiderPersonalAccidentSumInsured = riderSumInsured.RiderPersonalAccidentSumInsured;
        QuoteRequest.RiderAccidentalDeathSumInsured = riderSumInsured.RiderAccidentalDeathSumInsured;
        QuoteRequest.RiderHospitalCareSumInsured = riderSumInsured.RiderHospitalCareSumInsured;
        setRiderDetails({ ridersAndBenefit, riderSumInsured });

        getQuotation();

    };
    //console.log(QuoteRequest, "OCC Data")
    useEffect(() => {
        callMasterAPI();
    }, [])

    useEffect(() => {
        if (window.innerWidth >= 768) {
            window.addEventListener("scroll", () => {
                setScroll(window.scrollY > 10)
            })
        }
    },
        []);
    const generateQuotePDF = async () => {
        setDownloadQuotePDF(true);
        let element = document.getElementById('LifeQuotePage');
        let clonnedElement = element.cloneNode(true);
        // Ensure FontAwesome icons & styles are included
        let fontLink = document.createElement('link');
        fontLink.rel = 'stylesheet';
        fontLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/all.min.css';
        clonnedElement.appendChild(fontLink);
        const editBtn = clonnedElement.querySelector('.LifeEditCust ');
        const copyIcon = clonnedElement.querySelector('.fa-copy');
        let pdfBtn = clonnedElement.querySelector('.CallRequest');
        let ContactBtnFooter = clonnedElement.querySelector('.ContactBtnFooter');
        let hideQuote = clonnedElement.querySelectorAll('.IconContainer');
        hideQuote.forEach(itm => {
            itm.remove();
        });

        if (ContactBtnFooter) ContactBtnFooter.remove();
        if (pdfBtn) pdfBtn.remove();
        if (copyIcon) copyIcon.remove();
        if (editBtn) editBtn.remove();


        let option = {
            margin: 0,
            filename: (QuoteReq?.EnquiryNo || '').replace('/', '_') + "_Quotation" + "_Summary.pdf",
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 8, letterRendering: true, useCORS: true, dpi: 192 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'l', putOnlyUsedFonts: true },
            enableLinks: true,
            height: clonnedElement.scrollHeight,
            pagebreak: { mode: ['avoid-all','css','legacy'], before: '.page-break' }
        }

        try {

            await html2pdf().set(option).from(clonnedElement).save();
            setDownloadQuotePDF(false);

        } catch (error) {
            console.log({ error });
        }
    }    

    const handleAutoPay = (flag) => {
        QuoteRequest.isAutoPay = flag;
        getQuotation();
    }

    const hideQuotes = (tranKey) => {
        if (Response.length === 1) {
            alert(`You can not hide all the ${Response.length === 1 ? "Quote" : "Quotes"}`);
        } else {
            const filteredQuotes = Response.filter(qt => qt.TransKey !== tranKey);
            setResponse(filteredQuotes);
            let hQuotes = [...hiddenQuotes, tranKey];
            setHiddenQuotes(hQuotes);

        }  
    }

    const showAllQuotes = () => {
        setResponse(allResponse);
        setHiddenQuotes([])
    }


    useEffect(() => {
        const handleClick = (e) => {
            if (isLoading) {
                setQuoteLoading(true);

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = setTimeout(() => {
                    setQuoteLoading(false);
                }, 2000);
               
            }
        };

        if (isLoading) {
            document.addEventListener('click', handleClick, true);
        } else {
            document.removeEventListener('click', handleClick, true);
            setQuoteLoading(false);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        }

        return () => {
            document.removeEventListener('click', handleClick, true);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [isLoading]);

    const close = () => {
        setQuoteLoading(false)
    }

    return (
        <>
            {isQuoteLoading && <QuoteWaitingModal isQuoteLoading={isQuoteLoading} close={close} />}
            {downloadQuotePDF ? <div className="IsDownlodPDF"><span class="PDFloader"></span> <span class="PDFloaderText">Generating PDF</span></div> : ""}
            {isPageLoaded &&
                <div className="LifeQuoteMainPage" id="LifeQuotePage" style={{ pointerEvents: isLoading ? "none" : "auto" }}>
                    <div className="progress">
                        <div className={scroll ? "progress-bar scrolled " : "progress-bar"} role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100"></div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 life_user_detail1">
                                <div className="Sticky-Left-Column">
                                    <LifeQuoteDetail
                                        UpdateResult={UpdateResult}
                                        UpdateCoverTillAgeOnDOB={data => setQuoteRequest({ ...QuoteRequest, CoverTillAge: data })}
                                        formReq={formReq}
                                        Data={QuoteRequest}
                                        shareData={history?.location?.state?.Req}
                                        getQuoteOnchange={getQuoteOnchange}
                                        IsFromWomenComponent={IsFromWomenComponent}
                                        CallQuoteWithRiderAddons={CallQuoteWithRiderAddons}
                                        isHousewife={isHousewife}
                                        allTermLifePath={allTermLifePath}
                                        OccupationList={OccupationList ?? []}
                                        EducationList={EducationList ?? []}
                                        occupationOptions={occupationOptions}
                                        
                                    />
                                    <div className="blank_container"></div>
                                    <div className="blank_div"></div>

                                </div>
                            </div>
                            <div className="col-lg-9">
                                <LifeQuoteEnquiry
                                    isLoading={isLoading}
                                    QuoteRequest={QuoteRequest}
                                    Data={Response}
                                    enq={QuoteReq?.EnquiryNo}
                                    IsAscendingOrder={IsAscendingOrder}
                                    setAscendingOrder={(data) => setAscendingOrder(data)}
                                    setGst={handleGst}
                                    hiddenQuotes={hiddenQuotes}
                                />
                                <div className="CallRequest">
                                    <button onClick={generateQuotePDF} className="showOpt" id="MoreOption">
                                        <span><BsStars /></span>
                                        <span><FaRegFilePdf /></span>
                                        <span>Generate PDF</span>
                                    </button>
                                </div>

                                {isLoader ?
                                    <div>
                                        {TermLifeLoaderBox.slice(0, 2).map((res) => (
                                            <LifeQuotationCard
                                                quoteValue={res}
                                                Data={PrvTwoData}
                                                details={QuoteReq}
                                                QCardLoader={isLoader}
                                            />
                                        ))}
                                    </div>
                                    :
                                    <div>
                                        {Response?.sort((a, b) => IsAscendingOrder ? a.NetPremium - b.NetPremium : b.NetPremium - a.NetPremium)?.map((quoteValue, i) => quoteValue.QuoteStatus && (
                                            <LifeQuotationCard
                                                key={i}
                                                quoteValue={quoteValue}
                                                Data={QuoteRequest.CoverTillAge}
                                                occData={QuoteRequest.Occupation}
                                                QR={QuoteRequest}
                                                IsFromHouseWifeComponent={IsFromHouseWifeComponent}
                                                gstEnable={gstEnable}
                                                RiderDetails={RiderDetails}
                                                setSelectedQuoteKey={key => setSelectedQuoteKey(key)}
                                                selectedQuoteKey={selectedQuoteKey}
                                                handleAutoPay={handleAutoPay}
                                                Quotes={Response}
                                                hideQuotes={hideQuotes}
                                            />
                                        ))}
                                        {!isLoading && Response.length === 0 && <p className="NQAvailable">No Quotes Available for Above Scenario</p>}
                                    </div>
                                }
                                <QuoteFooter
                                    MobileNo={QuoteRequest?.MobileNo}
                                    goToContact={goToContact}
                                    reqCallBack={getCallBack}

                                />
                                <div>

                                    {hiddenQuotes.length > 0 && < div class="ClearQuote" onClick={showAllQuotes}>Show {hiddenQuotes.length} Hidden {hiddenQuotes.length > 1 ? "Quotes" : "Quote"}</div>}

                                    {showActivityDetectionPopup && !isPopupClosed &&
                                        /* <UserActivityDetection
                                             reqCallBack={getCallBack}
                                             onClose={handlePopupClose}
                                             IsMobileNumber={QuoteRequest?.MobileNo}
                                         />*/
                                        <MouseAwayPopup IsMobileNumber={QuoteRequest?.MobileNo} onClose={handlePopupClose}/>

                                    }
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            }
       
        </>
    );
};
export default SmcLifeQuote;
